import { FC, useEffect } from 'react'
import { Input } from 'antd'
import { useIMask } from 'react-imask'
import { useFirstMountState, usePrevious } from 'react-use'

interface PhoneControlProps {
    value?: string
    onChange?: (value: string) => void
    disabled?: boolean
    placeholder?: string
}

const PhoneControl: FC<PhoneControlProps> = ({ value: propValue, onChange, disabled, placeholder }) => {
    const opts = { mask: '+7 (000) 000-00-00' }
    const { ref, value, setValue } = useIMask(opts, {
        onAccept: (maskedValue) => {
            if (onChange && maskedValue !== propValue) {
                onChange(maskedValue)
            }
        },
    })

    const prevValue = usePrevious(value)
    const isMount = useFirstMountState()

    useEffect(() => {
        if (isMount) return
        if (propValue !== undefined && propValue !== value) {
            setValue(propValue || '')
        }
        // Синхронизируем маску только при смене значения снаружи; с value эффект сбрасывал бы ввод
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propValue, isMount])

    useEffect(() => {
        if (isMount) return
        if (propValue === value) return
        if (value !== prevValue && onChange) {
            onChange(value)
        }
        // Реагируем только на ввод в маске; onChange от формы может меняться на каждом рендере
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, prevValue, isMount])

    return (
        <Input
            ref={(el) => {
                if (el?.input) {
                    ref.current = el.input
                }
            }}
            value={value}
            disabled={disabled}
            placeholder={placeholder || '+7 (999) 999-99-99'}
        />
    )
}

export default PhoneControl

